import axios from 'axios';
import { Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import bootstrapPlugin from '@fullcalendar/bootstrap5';

import noLocale from '@fullcalendar/core/locales/nb';
import svLocale from '@fullcalendar/core/locales/sv';

TABS.calendar = (function () {
    return {
        submitInProgress: false,
        filter:           {
            product_id:      0,
            web_category_id: 0,
            office_id:       0,
            product_type:    0
        },
        instance:         null,
        classOptions:     [],
        productOptions:   [],
        loadedCallback:   null,
        pendingRequests:  new Map(),
        debounceTimers:   new Map(),
        init:             async function () {
            document.addEventListener('click', function (event) {
                const orderLesson = event.target.closest('._orderLesson');
                if (orderLesson) {
                    TABS.calendar.clickLesson(orderLesson);
                }
                const teacherList = event.target.closest('._teacherList li');
                if (teacherList) {
                    TABS.calendar.clickTeacher(teacherList);
                }
                const backToList = event.target.closest('._backToList');
                if (backToList) {
                    TABS.calendar.clickBack(backToList);
                }
                const calendarDateClick = event.target.closest('.fc-daygrid-day-top');
                if (calendarDateClick) {
                    const d = (calendarDateClick.closest('.fc-day').dataset.date);

                    TABS.calendar.selectDay(d)
                    TABS.calendar.getSlots(d, d)
                }

                const bookCourse = event.target.closest('.bookCourse');
                if (bookCourse) {
                    if (TABS.calendar.submitInProgress) {
                        return;
                    }
                    TABS.calendar.submitInProgress = true;
                    TABS.api.loadCourse(bookCourse, bookCourse.dataset['course_id'], bookCourse.dataset['class_id'], bookCourse.dataset['office_id'])
                }
            });
            if (document.querySelectorAll('._teacherList li').length === 1) {
                document.querySelector('._teacherList li').click();
            }

            this.filter.office_id = TABS.api.officeId;
            if (!this.filter.office_id && document.getElementById('_officeFilter')) {
                this.filter.office_id = document.getElementById('_officeFilter').value;
            }

            if (document.getElementById('calendar')) {
                if (!window.filter_options) {
                    await this.getFilterOptions();
                }
                this.initCalendar();
            }
        },

        clickLesson:  function (el) {
            if (TABS.calendar.submitInProgress) {
                return;
            }
            TABS.calendar.submitInProgress = true;

            let post = new URLSearchParams(new FormData(document.getElementById('_slot' + el.dataset.slot_id))).toString() + '&product_id=' + TABS.calendar.filter.product_id + '&office_id=' + TABS.calendar.filter.office_id;
            if (TABS.util.getUrlParameter('tabs_jwt')) {
                post += '&vippsToken=' + TABS.util.getUrlParameter('tabs_jwt');
            }
            axios.post(TABS.api.getHost() + '/api/v2/booking', post, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            })
                .then(response => response.data)
                .then(html => {
                    TABS.calendar.submitInProgress = false;
                    TABS.api.openModal(html)
                })
                .catch(error => {
                    console.error(error);
                    alert(TABS.$t('Noe gikk galt. Vennligst last inn siden på nytt og prøv igjen.'));
                    TABS.calendar.submitInProgress = false;
                });
        },
        clickTeacher: function (el) {
            const teacher_id = el.dataset.teacher_id;
            document.querySelector('._selectedTeacher').style.display = 'block';
            document.querySelector('._selectedTeacher').textContent = el.querySelector('.TeacherlName').textContent;
            document.querySelectorAll('._lessonList').forEach((el) => {
                el.style.display = 'none'
            });
            document.getElementById('_slots_' + teacher_id).style.display = 'block';
            document.querySelector('._slotRelated').style.display = 'block';
            document.querySelectorAll('._teacherRelated').forEach((el) => {
                el.style.display = 'none'
            });
        },
        clickBack:    function (event) {
            document.querySelectorAll('._selectedTeacher').forEach(el => el.style.display = 'none');
            document.querySelector('._selectedTeacher').textContent = '';
            document.querySelectorAll('._lessonList').forEach(el => el.style.display = 'none');
            document.querySelectorAll('._slotRelated').forEach(el => el.style.display = 'none');
            document.querySelectorAll('._teacherRelated').forEach(el => el.style.display = 'block');
        },

        getFilterOptions:    async function () {
            const response = await axios.get(TABS.api.getEndPoint('calendar/filter'))
            console.log({ data: response.data });

            window.filter_options = response.data.products;
        },
        debounceEventSource: function (sourceId, fetchFn, delay = 200) {
            return function (fetchInfo, successCallback, failureCallback) {
                // Cancel any pending request for this source
                if (TABS.calendar.pendingRequests.has(sourceId)) {
                    TABS.calendar.pendingRequests.delete(sourceId);
                }

                // Clear existing timer for this source
                if (TABS.calendar.debounceTimers.has(sourceId)) {
                    clearTimeout(TABS.calendar.debounceTimers.get(sourceId));
                }

                // Set new debounced timer
                const timer = setTimeout(() => {
                    const request = fetchFn(fetchInfo, successCallback, failureCallback);
                    if (!request) {
                        return;
                    }
                    // Store the request if it returns a promise or has an abort method
                    TABS.calendar.pendingRequests.set(sourceId, request);
                    // Cleanup after request completion
                    request.finally(() => {
                        TABS.calendar.pendingRequests.delete(sourceId);
                    });

                    TABS.calendar.debounceTimers.delete(sourceId);
                }, delay);

                TABS.calendar.debounceTimers.set(sourceId, timer);
            };
        },
        initCalendar:        function () {
            let calendarLocale;
            switch (window.locale || 'no') {
                case 'sv':
                    calendarLocale = svLocale;
                    break;
                case 'no':
                default:
                    calendarLocale = noLocale;
            }

            let calendarEl = document.getElementById('calendar');

            let dateFilter = document.getElementById('_dateFilter').value

            TABS.calendar.instance = new Calendar(calendarEl, {
                plugins:         [dayGridPlugin, bootstrapPlugin],
                themeSystem:     'bootstrap5',
                initialView:     'dayGridMonth',
                height:          'auto',
                headerToolbar:   {
                    left:   '',
                    center: 'prev title next',
                    right:  ''
                },
                dayMaxEventRows: 2,
                moreLinkContent: TABS.$t('flere'),
                defaultDate:     dateFilter,
                visibleRange:    {
                    start: new Date(),
                },
                locale:          calendarLocale,
                eventSources:    [
                    {
                        events: TABS.calendar.debounceEventSource('calendar-events', (fetchInfo, successCallback, failureCallback) => {
                            const data = TABS.calendar.filter
                            if (!data.product_id) {
                                successCallback([]);
                                return
                            }
                            data.start = fetchInfo.startStr;
                            data.end = fetchInfo.endStr;
                            return axios.post(TABS.api.getHost() + '/calendar/events/', data, {
                                headers: {
                                    'Content-Type': 'multipart/form-data'
                                },
                            })
                            .then(function (response) {
                                successCallback(response.data)
                            }).catch(function (xhr) {
                                failureCallback('Request failed: ' + xhr.statusText);
                            })
                        })
                    }
                ],
                loading:         function (isLoading) {
                    TABS.calendar.toggleLoadingAnimation(isLoading);

                    if (!isLoading && TABS.calendar.loadedCallback) {
                        TABS.calendar.loadedCallback();
                        TABS.calendar.loadedCallback = null;
                    }
                },
                dayCellContent:  function (arg) {
                    const dayNumber = arg.dayNumberText;
                    return {
                        html: `
                        <div class="fc-daygrid-day-top">
                            <div class="Signal"></div>
                            <div class="Mark">${dayNumber}</div>
                        </div>
                    `
                    }
                },
                eventContent:    function (arg) {
                    return {
                        html: `
                            <div class="fc-event-title">${arg.event.title}
                                <div class="AvailPlaces">${arg.event.extendedProps.description}</div>
                            </div>
                        `
                    }
                },
                eventDidMount:   function (val) {
                    const fcDaygridDayFrame = val.el.closest('.fc-daygrid-day-frame')
                    if (!fcDaygridDayFrame) {
                        return;
                    }
                    const daygridDayTop = fcDaygridDayFrame.querySelector('.fc-daygrid-day-top');
                    if (!daygridDayTop) {
                        return;
                    }
                    if (val.event.extendedProps.isHolidayEvent) {
                        daygridDayTop.classList.add('HolidaySignal')
                    } else {
                        daygridDayTop.classList.add('Bookable')
                    }
                },
                eventClick:      function (arg) {
                    const d = arg.event.startStr
                    TABS.calendar.selectDay(d)
                    TABS.calendar.getSlots(d, d, arg.event.cid)
                },
                dateClick:       function (arg) {
                    const d = arg.dateStr
                    TABS.calendar.selectDay(d)
                    TABS.calendar.getSlots(d, d)
                },
                viewDidMount:    function () {
                    // Trigger a resize event as sometimes the calendar has incorrect width
                    window.dispatchEvent(new Event('resize'));
                    setTimeout(() => {
                        window.dispatchEvent(new Event('resize'));
                    }, 200)
                }
            });
            TABS.calendar.instance.render();

            TABS.calendar.initFilterRow();
            TABS.calendar.initClassSelect();
            TABS.calendar.initProductSelect();

            TABS.calendar.initFilters();
            TABS.calendar.setPreselectedValues();
        },

        toggleLoadingAnimation: function (isLoading) {
            document.querySelectorAll('#calendar-loader, #LoadingCalendar').forEach(function (el) {
                el.style['display'] = (isLoading ? 'block' : 'none');
            });
        },

        initFilterRow: function () {
            var div = document.createElement('div');
            div.className = 'row fc-filters mb-2';
            div.innerHTML = `
                <div class="col-12 col-sm-12 col-md-6" id="class-select-wrapper"></div>
                <div class="col-12 col-sm-12 col-md-6" style="margin-left: 0;" id="product-select-wrapper"></div>`;
            document.querySelector('.fc-toolbar').insertAdjacentElement('afterend', div);
        },

        initClassSelect: function () {
            const classSelect = document.createElement('select');
            classSelect.className = 'form-control rounded-0 mb-2 mb-lg-0';
            classSelect.id = 'class_filter';
            classSelect.innerHTML = '<option value="0" selected>' + TABS.$t('Velg klasse') + '</option>';
            classSelect.onchange = function () {
                TABS.calendar.updateProductsSelect()
            };

            document.querySelector('#class-select-wrapper').appendChild(classSelect);

        },

        initProductSelect: function () {
            const productSelect = document.createElement('select');
            productSelect.className = 'form-control rounded-0 mb-2 mb-lg-0';
            productSelect.id = 'calendar_filter';
            productSelect.onchange = function () {
                const params = this.value.split('-');
                TABS.calendar.filter.product_id = params[0];
                TABS.calendar.filter.web_category_id = params[1];
                TABS.calendar.filter.product_type = params[2];
                TABS.calendar.instance.refetchEvents();
            };

            document.querySelector('#product-select-wrapper').appendChild(productSelect);
        },

        initFilters: function () {
            let options = filter_options[TABS.api.officeId];
            if (!options) {
                let key = Object.keys(filter_options)[0];
                options = filter_options[key];
            }
            TABS.calendar.classOptions = [];
            /** Example entry in options:
             * [{
             * product_id: 286
             * product_name: "Grunnkurs"
             * product_name_on_web: ""
             * product_type: 3
             * web_category_id: 207
             * web_category_name: "Motorsykkel (A1)"
             * web_category_sort_order: 1
             * }]
             */

            const classSelect = document.getElementById('class_filter');
            // Add web categories to select
            options.map(function (option) {
                const classExists = TABS.calendar.classOptions.indexOf(option.web_category_id) > -1;
                if (!classExists) {
                    TABS.calendar.addOptionToSelect(classSelect, option.web_category_id, option.web_category_name);
                    TABS.calendar.classOptions.push(option.web_category_id);
                }

                TABS.calendar.productOptions.push(option);
            })
        },

        setPreselectedValues: function () {
            const preselectedCategory = TABS.calendar.getUrlParam('category') || document.getElementById('_categoryFilter').value;
            if (preselectedCategory) {
                const selectClass = document.getElementById('class_filter');
                selectClass.value = preselectedCategory;
                TABS.calendar.updateProductsSelect()
            }

            const preselectedProduct = TABS.calendar.getUrlParam('product') || document.getElementById('_productFilter').value;
            if (preselectedProduct) {
                const productSelect = document.getElementById('calendar_filter');
                const productOptions = productSelect.options;
                for (let i = 0; i < productOptions.length; i++) {
                    if (productOptions[i].value.indexOf(preselectedProduct + '-' + preselectedCategory) > -1) {
                        productOptions[i].selected = true;
                        break;
                    }
                }

                productSelect.dispatchEvent(new Event('change'));
            }

            const preselectedDate = TABS.calendar.getUrlParam('date') || document.getElementById('_dateFilter').value;
            if (preselectedDate) {
                TABS.calendar.instance.gotoDate(preselectedDate);
                document.querySelector('.fc-day[data-date="' + preselectedDate + '"] .fc-daygrid-day-top').click();
            }
        },

        addOptionToSelect: function (el, val, text) {
            let option = document.createElement('option');
            option.value = val;
            option.text = text;
            el.appendChild(option);
        },

        updateProductsSelect: function () {
            const classSelect = document.getElementById('class_filter');
            const productSelect = document.getElementById('calendar_filter');

            productSelect.innerHTML = '';

            const selectedClass = classSelect.value;
            TABS.calendar.productOptions.map(option => {
                if (option.web_category_id == selectedClass) {
                    const value = option.product_id + '-' + option.web_category_id + '-' + option.product_type;
                    TABS.calendar.addOptionToSelect(productSelect, value, option.product_name);
                }
            })
            productSelect.dispatchEvent(new Event('change'));

            document.querySelectorAll('#slot-result').forEach(function (el) {
                el.innerHTML = '<p>' + TABS.$t('Velg en dag i kalenderen') + '</p>'
            });
            document.querySelectorAll('.Bookable').forEach(el => el.classList.remove('Bookable'));
            document.querySelectorAll('.IsHoliday').forEach(el => el.classList.remove('IsHoliday'));
        },

        getUrlParam: function (name) {
            const urlParams = new URLSearchParams(window.location.search);
            return urlParams.get(name);
        },

        selectDay: function (date) {
            document.querySelectorAll('.fc-daygrid-day .fc-daygrid-day-top').forEach(function (el) {
                el.classList.remove('Active');
            });

            const clickedDate = document.querySelector('.fc-daygrid-day[data-date="' + date + '"] .fc-daygrid-day-top');
            if (clickedDate) {
                clickedDate.classList.add('Active');
            }
        },

        getSlots: function (dateStart, dateEnd, cid) {
            TABS.calendar.toggleLoadingAnimation(true);
            if (!dateEnd) {
                dateEnd = dateStart;
            }
            if (!cid) {
                cid = 0;
            }

            const formData = new FormData;
            formData.append('product_id', TABS.calendar.filter.product_id);
            formData.append('web_category_id', TABS.calendar.filter.web_category_id);
            formData.append('office_id', TABS.calendar.filter.office_id);
            formData.append('product_type', TABS.calendar.filter.product_type);
            formData.append('start', dateStart);
            formData.append('end', dateEnd);
            formData.append('cid', cid);

            axios.post(TABS.api.getHost() + '/calendar/event_list/', formData).then(response => {
                const html = response.data;
                const resultList = document.getElementById('resultList') ?? document.getElementById('slot-result');
                resultList.innerHTML = html;
                TABS.calendar.toggleLoadingAnimation(false);
            })
        },
    }
})();